var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 19,
    viewBox: "0 0 8 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M2.758 6.05v4.246"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 5.517 0)",
    cx: 2.758,
    cy: 2.758,
    r: 2.758
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 5.517 0)",
    cx: 2.758,
    cy: 13.792,
    r: 2.758
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE5cHgiIHZpZXdCb3g9IjAgMCA4IDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPkdyb3VwIDcgQ29weTwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtNy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGxpbmUgeDE9IjIuNzU4Mzk2MDUiIHkxPSI2LjA0OTgwNDY5IiB4Mj0iMi43NTgzOTYwNSIgeTI9IjEwLjI5NTY1NDMiIGlkPSJMaW5lLTkiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiPjwvbGluZT4KICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC1Db3B5LTUxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjc1ODM5NiwgMi43NTgzOTYpIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTIuNzU4Mzk2LCAtMi43NTgzOTYpICIgY3g9IjIuNzU4Mzk2MDUiIGN5PSIyLjc1ODM5NjA1IiByPSIyLjc1ODM5NjA1Ij48L2NpcmNsZT4KICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbC1Db3B5LTUyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjc1ODM5NiwgMTMuNzkxOTgwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC0yLjc1ODM5NiwgLTEzLjc5MTk4MCkgIiBjeD0iMi43NTgzOTYwNSIgY3k9IjEzLjc5MTk4MDIiIHI9IjIuNzU4Mzk2MDUiPjwvY2lyY2xlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgStart as ReactComponent };